module.exports = __webpack_public_path__ + "static/media/banner-of-organizations-details.a8f7e82c.svg";